import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../../store';
import { deleteMethod, get, post, put } from '../../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  loggedInInspectionType: [],
  selectedInspectionType: [],
  currentInspectionType: [],
  documentTypes: [],
  documents: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'InspectionType',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET InspectionTypeManagement
    getInspectionTypeSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET InspectionTypeManagement
    updateCurrentLoggedInInspectionTypeData(state, action) {
      state.loggedInInspectionType = action.payload;
    },

    // GET InspectionTypeManagement
    getCurrentInspectionTypeSuccess(state, action) {
      state.currentInspectionType = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    // GET InspectionTypeManagement
    getSpecificInspectionTypeDataSuccess(state, action) {
      state.selectedInspectionType = action.payload.data;
      state.documentTypes = action.payload.documentTypes;
      state.documents = action.payload.documents;
    },

    addOrUpdateInspectionTypes(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getInspectionType() {
  return async () => {
    try {
      const response = await get(`InspectionType`);
      if (response.status) {
        dispatch(slice.actions.getInspectionTypeSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInspectionTypeById(userId) {
  return async () => {
    try {
      const response = await get(`InspectionTypeById?userId=${userId}`);
      if (response.status) {
        dispatch(slice.actions.getInspectionTypeSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addInspectionType(body) {
  return async () => {
    try {
      const response = await post(`InspectionType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateInspectionType(body) {
  return async () => {
    try {
      const response = await put(`InspectionType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deleteInspectionType(body) {
  return async () => {
    try {
      const response = await deleteMethod(`InspectionType`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateInspectionTypes(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
